import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';


const DrawTopView = ({  doorData = null }) => {
    const svgRef1 = useRef();
    
    useEffect(() => {
        if (!svgRef1.current) return;

        if ((isNaN(doorData.frameData.frameWidth))  || (parseFloat(doorData.frameData.frameWidth)  < 10)) {return;} //prevent one number numbering
        if ((isNaN(doorData.frameData.frameHeight)) || (parseFloat(doorData.frameData.frameHeight) < 10)) {return;} //prevent one number numbering

        d3.select(svgRef1.current).selectAll('*').remove();

        const svg = d3.select(svgRef1.current)
        .append('svg')
        .attr('width', 5*(parseFloat(doorData.frameData.frameWidth) + 2*parseFloat(doorData.frameData.sideLiteSize)) + 70 )
        .attr('height', 95)
        /*.style('border', '2px solid black');*/
        topView(svg, doorData);
    
    }, [doorData]); 

    function printText(svg, x, y, text, fontColor = 'black', fontSize = '14px', fontFamily = 'Arial') {
        svg.append('text')
          .attr('x', x)
          .attr('y', y)
          .text(text)
          .attr('fill', fontColor)
          .attr('font-size', fontSize)
          .attr('font-family', fontFamily);
    }
    function drawLine(svg, x1, y1, x2, y2, color = 'black', thickness = 4) {
        svg.append('line')
          .attr('x1', x1)
          .attr('y1', y1)
          .attr('x2', x2)
          .attr('y2', y2)
          .attr('stroke', color)
          .attr('stroke-width', thickness);
      }

    function drawLineWithOutline(svg, x1, y1, x2, y2, color = 'white', thickness = 2, outlineColor = 'black', outlineWidth = 1) {
        // First draw the outline (behind)
        svg.append('line')
          .attr('x1', x1)
          .attr('y1', y1)
          .attr('x2', x2)
          .attr('y2', y2)
          .attr('stroke', outlineColor)
          .attr('stroke-width', thickness + 2 * outlineWidth); // Outline wraps around
      
        // Then draw the main colored line (on top)
        svg.append('line')
          .attr('x1', x1)
          .attr('y1', y1)
          .attr('x2', x2)
          .attr('y2', y2)
          .attr('stroke', color)
          .attr('stroke-width', thickness);
    }
    function drawScreen(svg, x, y, height, totalLength, numSegments, color = 'white', thickness = 2) {
        const width = totalLength / numSegments;
        const points = [];
        let direction = -1;
      
        for (let i = 0; i <= numSegments; i++) {
          points.push([x + i * width, y + direction * height]);
          direction *= -1;
        }
      
        for (let i = 0; i < points.length - 1; i++) {
          drawLineWithOutline(svg, points[i][0], points[i][1], points[i + 1][0], points[i + 1][1], color, thickness);
        }
      }
                    
    function drawEndRect(svg, x, y, width, height, color = '#E0E0E0')
    {
        svg.append('rect')
        .attr('x', x)
        .attr('y', y)
        .attr('width', width)
        .attr('height', height)
        .attr('stroke', 'green') // Border color
        .attr('stroke-width', 0.5) // Border thickness
        .attr('fill', color); 
    }
    function topView(svg, doorData)
    {
        //alert(JSON.stringify(doorData.frameData, null, 2));
        if (!doorData?.frameData?.selectedDoor) return;
        //if (!doorData?.frameData?.frameWidth) return;
        //if (!doorData?.frameData?.frameHeght) return;
        //if (!doorData?.frameData?.sideLiteSize) return;

        let height = 20;
        let Y = 40;
        const xOffset = 0;
        let text = "3\"";    
        if ( doorData.frameData.retractableScreen === 'Yes') {
            height = 30;
            text = "4 1/2\"";
        }
        let width = 0; let w1,w2,w3,w4, w2w3;
        if ([1, 5].includes(doorData.frameData.selectedDoor.id)) {
            width = parseFloat(doorData.frameData.frameWidth);
            w1 = 0; w4 = 0; w2w3 = width;
        }
        if ([2, 6].includes(doorData.frameData.selectedDoor.id)) {
            width = parseFloat(doorData.frameData.frameWidth) + parseFloat(doorData.frameData.sideLiteSize);
            w1 = parseFloat(doorData.frameData.sideLiteSize); w4 = 0; w2w3 = parseFloat(doorData.frameData.frameWidth);
        }
        if ([3, 7].includes(doorData.frameData.selectedDoor.id)) {
            width = parseFloat(doorData.frameData.frameWidth) + parseFloat(doorData.frameData.sideLiteSize);
            w1 = 0; w4 = parseFloat(doorData.frameData.sideLiteSize); w2w3 = parseFloat(doorData.frameData.frameWidth);
        }
        if ([4, 8].includes(doorData.frameData.selectedDoor.id)) {
            width = parseFloat(doorData.frameData.frameWidth) + 2*parseFloat(doorData.frameData.sideLiteSize);
            w1 = parseFloat(doorData.frameData.sideLiteSize); w4 = parseFloat(doorData.frameData.sideLiteSize);
            w2w3 = parseFloat(doorData.frameData.frameWidth);
        }

        width = width*5 + 20;
        w1 = 5*w1; w2w3 = 5*w2w3 + 20; w4 = 5*w4; 

        if (doorData.frameData.swing === 'Inswing'){
  
          let x1,x2,y1,y2,x3,x4,y3,y4;
            if ([1, 2, 3, 4].includes(doorData.frameData.selectedDoor.id)) {
                if (doorData.frameData.hinges === 'Left') {
                    x1 = xOffset + w1; y1 = Y;
                    x2 = xOffset + w1 + w2w3-xOffset - 20; y2 = 5;
                    drawLine(svg, x1,y1, x2, y2);
                }
                else{
                    x1 = xOffset + w1 + w2w3; y1 = Y;
                    x2 = xOffset + w1 + 20; y2 = 5;
                    drawLine(svg, x1,y1, x2, y2);
                }
            }
            if ([5, 6, 7, 8].includes(doorData.frameData.selectedDoor.id)) {
                if (doorData.frameData.hinges === 'Left') {
                    x1 = xOffset + w1; y1 = Y;
                    x2 = xOffset + w1 + w2w3/2-20; y2 = 5;
                    drawLine(svg, x1,y1, x2, y2);

                    x3 = xOffset + w1 + w2w3; y3 = Y;
                    x4 = xOffset + w1 + w2w3/2 + 20; y4 = Y/2;
                    drawLine(svg, x3,y3, x4, y4);
                }
                else{
                    x1 = xOffset + w1; y1 = Y;
                    x2 = xOffset + w1 + w2w3/2-20; y2 = Y/2;
                    drawLine(svg, x1,y1, x2, y2);

                    x3 = xOffset + w1 + w2w3; y3 = Y;
                    x4 = xOffset + w1 + w2w3/2 + 20; y4 = 5;
                    drawLine(svg, x3,y3, x4, y4);
                }
            }
            if ( doorData.frameData.retractableScreen === 'Yes') {
                let screenColor  = '#E0E0E0';
                if (doorData.finish.screenFrameColor === 'Gentek'){
                    screenColor = doorData.finish.gentekColor7;
                }
                drawScreen(svg,  x1 + 10, Y + height + 10, 4, ( w2w3 - 10)*0.75, 20, screenColor, 4); //zigzag
                drawEndRect(svg, x1 + 10 + ( w2w3 - 10)*0.75, Y + height + 5, 5, 10, screenColor);    //zigzag lock
                drawEndRect(svg, x1, Y + height, 10, 15);                               //left rectangle
                drawEndRect(svg, x1 + w2w3 - 10,  Y + height, 10, 15);                  //right rectangle
            }
        }
        if (doorData.frameData.swing === 'Outswing'){
            let x1,x2,y1,y2,x3,x4,y3,y4;
            if ([1, 2, 3, 4].includes(doorData.frameData.selectedDoor.id)) {
                if (doorData.frameData.hinges === 'Left') {
                    //alert('outswing + left');
                    x1 = xOffset + w1; y1 = Y + height;
                    x2 = xOffset + w1 + w2w3-xOffset - 20; y2 = Y +  height + 20;
                    //alert( x1 + "," + y1 + "," + x2 + "," + y2);
                    drawLine(svg, x1,y1, x2, y2);                }
                else{
                    x1 = xOffset + w1 + w2w3; y1 = Y + height;
                    x2 = xOffset + w1 + 20; y2 = Y + height + 20;
                    drawLine(svg, x1,y1, x2, y2);
                }
            }
            if ([5, 6, 7, 8].includes(doorData.frameData.selectedDoor.id)) {
                if (doorData.frameData.hinges === 'Left') {
                    x1 = xOffset + w1; y1 = Y + height;
                    x2 = xOffset + w1 + w2w3/2-20; y2 = Y + height + 20;
                    drawLine(svg, x1,y1, x2, y2);

                    x3 = xOffset + w1 + w2w3; y3 = Y + height;
                    x4 = xOffset + w1 + w2w3/2 + 20; y4 = Y + height + 10;
                    drawLine(svg, x3,y3, x4, y4);
                }
                else{
                    x1 = xOffset + w1; y1 = Y + height;
                    x2 = xOffset + w1 + w2w3/2-20; y2 = Y + height + 10;
                    drawLine(svg, x1,y1, x2, y2);

                    x3 = xOffset + w1 + w2w3; y3 = Y + height;
                    x4 = xOffset + w1 + w2w3/2 + 20; y4 = Y + height + 20;
                    drawLine(svg, x3,y3, x4, y4);
                }
            }
            if ( doorData.frameData.retractableScreen === 'Yes') {
                let screenColor  = '#E0E0E0';
                if (doorData.finish.screenFrameColor === 'Gentek'){
                    screenColor = doorData.finish.gentekColor7;
                }
                drawScreen(svg,  x1 + 10, Y  - 10, 4, ( w2w3 - 10)*0.75, 20, screenColor, 4); //zigzag
                drawEndRect(svg, x1 + 10 + ( w2w3 - 10)*0.75, Y - 15, 5, 10, screenColor);    //zigzag lock
                drawEndRect(svg, x1, Y - 15, 10, 15);                           //left rectangle
                drawEndRect(svg, x1 + w2w3 - 10,  Y - 15 , 10, 15);             //right rectangle
            }     
        }

        svg.append('rect')
        .attr('x', 0)
        .attr('y', Y)
        .attr('width', width)
        .attr('height', height)
        .attr('stroke', 'black') // Border color
        .attr('stroke-width', 0.5) // Border thickness
        .attr('fill', '#E0E0E0'); 

        svg.append('rect')
        .attr('x', xOffset)
        .attr('y', Y)
        .attr('width', w1)
        .attr('height', height)
        .attr('stroke', 'black') // Border color
        .attr('stroke-width', 0.5) // Border thickness
        .attr('fill', '#E0E0E0'); 

        if ([1, 2, 3, 4].includes(doorData.frameData.selectedDoor.id)) {
            svg.append('rect')
            .attr('x', xOffset + w1)
            .attr('y', Y)
            .attr('width', w2w3)
            .attr('height', height)
            .attr('stroke', 'black') // Border color
            .attr('stroke-width', 0.5) // Border thickness
            .attr('fill', '#E0E0E0'); 
        }
        else{
            svg.append('rect')
            .attr('x', xOffset + w1)
            .attr('y', Y)
            .attr('width', w2w3/2)
            .attr('height', height)
            .attr('stroke', 'black') // Border color
            .attr('stroke-width', 1) // Border thickness
            .attr('fill', '#E0E0E0'); 

            svg.append('rect')
            .attr('x', xOffset + w1 + w2w3/2)
            .attr('y', Y)
            .attr('width', w2w3/2)
            .attr('height', height)
            .attr('stroke', 'black') // Border color
            .attr('stroke-width', 1) // Border thickness
            .attr('fill', '#E0E0E0'); 
        }
        
        svg.append('rect')
        .attr('x', xOffset + w1 + w2w3)
        .attr('y', Y)
        .attr('width', w4)
        .attr('height', height)
        .attr('stroke', 'black') // Border color
        .attr('stroke-width', 0.5) // Border thickness
        .attr('fill', '#E0E0E0'); 
        
        printText(svg, width + 15, Y + height/2 + 5, text);
    }
    function make_svg(){
        const svg = d3.select('body')
        .append('svg')
        .attr('width', 600)
        .attr('height', 300)
        .style('border', '2px solid black');
    }
    return (
        <div>
          {doorData?.frameData?.selectedDoor && <div><b>Top View</b></div>}  
          {doorData?.frameData?.selectedDoor && <div>Interior</div>}  
         <div ref={svgRef1}></div>
         {doorData?.frameData?.selectedDoor && <div>Exterior</div>}  
        </div>
    );
};

export default DrawTopView;
